import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";
import Configuration from "./Configuration";
import Report from "./Report";
import Summary from "./Summary";

export default function MonthlyReport() {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();

  const [cMenu, setCMenu] = useState("report");
  const [yearMonth, setYearMonth] = useState(`${year}-${month}`);

  const userInfo = useSelector((state) => state.userInfo);
  const canConfigure = hasPermission(userInfo.permissions, PERM.REPORT_STUDY_EDIT);

  // const menuDataSource = [
  //   { id: "configuration", name: "", icon: "preferences", disabled: !canConfigure, selected: cMenu === "configuration" },
  //   { id: "report", name: "Report", icon: "fa-regular fa-calendar-check", selected: cMenu === "report" },
  //   { id: "summary", name: "Summary", icon: "fa-solid fa-table", selected: cMenu === "summary" },
  // ];
  const [menuDataSource, setMenuDataSource] = useState(null);

  useEffect(() => {
    const menu = [
      { id: "configuration", name: "", icon: "preferences", disabled: !canConfigure },
      { id: "report", name: "Report", icon: "fa-regular fa-calendar-check", selected: true },
      { id: "summary", name: "Summary", icon: "fa-solid fa-table" },
    ];
    setMenuDataSource(menu);
  }, []);

  const handleClickMenu = (id, shouldSetYearMonth = true) => {
    if (shouldSetYearMonth) {
      setYearMonth(`${year}-${month}`);
    }
    setCMenu(id);
  };

  return (
    <React.Fragment>
      <Header title={"MONTHLY REPORT"} menuDataSource={menuDataSource} setCMenu={handleClickMenu} />
      <div style={{ margin: "40px auto", width: "95vw" }}>
        {cMenu === "configuration" ? (
          <Configuration />
        ) : cMenu === "report" ? (
          <Report handleClickMenu={handleClickMenu} setYearMonth={setYearMonth} yearMonth={yearMonth} />
        ) : cMenu === "summary" ? (
          <Summary handleClickMenu={handleClickMenu} setYearMonth={setYearMonth} yearMonth={yearMonth} />
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
}
